import {Role} from "../../shared/Role";

export const isUserAnAdmin = (context: any) => isAdminRole(getRoleFromContext(context));
export const isUserTrialAdmin = (context: any) => isTrialAdminRole(getRoleFromContext(context));
export const getRoleFromContext = (context: any) => context.$auth.user.role;
export const isAdminRole = (role: string) => role == Role.Admin;
export const isTrialAdminRole = (role: string) => role == Role.TrialAdmin;
